var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showModal
    ? _c(
        "div",
        { staticClass: "modal-custom-black", attrs: { id: _vm.modalId } },
        [
          _c("div", { staticClass: "modal-custom-black-content" }, [
            _c("div", { staticClass: "modal-custom-black-header" }, [
              !_vm.hideTopCloseButton
                ? _c(
                    "span",
                    {
                      staticClass: "modal-custom-black-close",
                      on: { click: _vm.hideModal }
                    },
                    [_vm._v("×")]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "modal-custom-black-body text-center d-flex flex-column justify-content-center"
              },
              [_vm._t("default")],
              2
            )
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1035b1ec", { render: render, staticRenderFns: staticRenderFns })
  }
}